var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLsCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Level_Status_Icon",
    "data-name": "Level Status Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#e1e7e9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(2 2)",
    fill: "#95adac"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(8.447 10.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M3.161,3.98a.817.817,0,0,1-.579-.24L-.76.4A.819.819,0,0,1-.76-.76.819.819,0,0,1,.4-.76L3.74,2.582a.819.819,0,0,1-.579,1.4Z",
    transform: "translate(1 3.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_6",
    "data-name": "Line 6",
    d: "M-.181,6.765a.817.817,0,0,1-.579-.24.819.819,0,0,1,0-1.158L5.366-.76a.819.819,0,0,1,1.158,0A.819.819,0,0,1,6.525.4L.4,6.525A.817.817,0,0,1-.181,6.765Z",
    transform: "translate(4.342 1)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLsCompleted);
export default __webpack_public_path__ + "static/media/icon_ls_completed.bac079b005d5cb361ee2250614983455.svg";
export { ForwardRef as ReactComponent };